(function(){function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s}return e})()({1:[function(require,module,exports){
/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
		// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
		if (ex.number === undefined || ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(window.self));

}

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}

},{}],2:[function(require,module,exports){
var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;

},{}],3:[function(require,module,exports){
var closest = require('./closest');

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;

},{"./closest":2}],4:[function(require,module,exports){
(function (global){
// Best place to find information on XHR features is:
// https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest

var reqfields = [
  'responseType', 'withCredentials', 'timeout', 'onprogress'
]

// Simple and small ajax function
// Takes a parameters object and a callback function
// Parameters:
//  - url: string, required
//  - headers: object of `{header_name: header_value, ...}`
//  - body:
//      + string (sets content type to 'application/x-www-form-urlencoded' if not set in headers)
//      + FormData (doesn't set content type so that browser will set as appropriate)
//  - method: 'GET', 'POST', etc. Defaults to 'GET' or 'POST' based on body
//  - cors: If your using cross-origin, you will need this true for IE8-9
//
// The following parameters are passed onto the xhr object.
// IMPORTANT NOTE: The caller is responsible for compatibility checking.
//  - responseType: string, various compatability, see xhr docs for enum options
//  - withCredentials: boolean, IE10+, CORS only
//  - timeout: long, ms timeout, IE8+
//  - onprogress: callback, IE10+
//
// Callback function prototype:
//  - statusCode from request
//  - response
//    + if responseType set and supported by browser, this is an object of some type (see docs)
//    + otherwise if request completed, this is the string text of the response
//    + if request is aborted, this is "Abort"
//    + if request times out, this is "Timeout"
//    + if request errors before completing (probably a CORS issue), this is "Error"
//  - request object
//
// Returns the request object. So you can call .abort() or other methods
//
// DEPRECATIONS:
//  - Passing a string instead of the params object has been removed!
//
exports.ajax = function (params, callback) {
  // Any variable used more than once is var'd here because
  // minification will munge the variables whereas it can't munge
  // the object access.
  var headers = params.headers || {}
    , body = params.body
    , method = params.method || (body ? 'POST' : 'GET')
    , called = false

  var req = getRequest(params.cors)

  function cb(statusCode, responseText) {
    return function () {
      if (!called) {
        callback(req.status === undefined ? statusCode : req.status,
                 req.status === 0 ? "Error" : (req.response || req.responseText || responseText),
                 req)
        called = true
      }
    }
  }

  req.open(method, params.url, true)

  var success = req.onload = cb(200)
  req.onreadystatechange = function () {
    if (req.readyState === 4) success()
  }
  req.onerror = cb(null, 'Error')
  req.ontimeout = cb(null, 'Timeout')
  req.onabort = cb(null, 'Abort')

  if (body) {
    setDefault(headers, 'X-Requested-With', 'XMLHttpRequest')

    if (!global.FormData || !(body instanceof global.FormData)) {
      setDefault(headers, 'Content-Type', 'application/x-www-form-urlencoded')
    }
  }

  for (var i = 0, len = reqfields.length, field; i < len; i++) {
    field = reqfields[i]
    if (params[field] !== undefined)
      req[field] = params[field]
  }

  for (var field in headers)
    req.setRequestHeader(field, headers[field])

  req.send(body)

  return req
}

function getRequest(cors) {
  // XDomainRequest is only way to do CORS in IE 8 and 9
  // But XDomainRequest isn't standards-compatible
  // Notably, it doesn't allow cookies to be sent or set by servers
  // IE 10+ is standards-compatible in its XMLHttpRequest
  // but IE 10 can still have an XDomainRequest object, so we don't want to use it
  if (cors && global.XDomainRequest && !/MSIE 1/.test(navigator.userAgent))
    return new XDomainRequest
  if (global.XMLHttpRequest)
    return new XMLHttpRequest
}

function setDefault(obj, key, value) {
  obj[key] = obj[key] || value
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],5:[function(require,module,exports){

require('classlist-polyfill');
var nanoajax = require('nanoajax');
var delegate = require('delegate');

function trim(s) {
  return s.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}

function extractScripts(node) {
  return Array.prototype.slice.call(node.querySelectorAll('script'), 0)
  .map(function (scriptNode) {
    return { content: scriptNode.innerHTML, src: scriptNode.src };
  });
}

function injectScripts(scripts) {
  scripts.forEach(function (s) {
    var script = document.createElement('script');
    if (s.content) {
      script.text = s.content;
    }
    if (s.src) {
      script.src = s.src;
    }
    document.head.appendChild(script);
  });
}

function _append(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    document.body.appendChild(nodes[i]);
  }
}

function _prepend(nodes) {
  for (var i = nodes.length - 1 ; i >= 0; i--) {
    document.body.insertBefore(nodes[i], document.body.firstChild);
  }
}

function _doAddNode(node, func) {
  var scripts = extractScripts(node);
  var nodes = Array.prototype.slice.call(node.childNodes, 0);
  func(nodes);
  injectScripts(scripts);
}

function appendToBody(node) {
  _doAddNode(node, _append);
}

function prependToBody(node) {
  _doAddNode(node, _prepend);
}

window.TES = window.TES || {};

var NagFooter = function (user) {
  var userData;

  if (window.Cookies('TESCookieV2')) {
    var cookieValue = window.Cookies('TESCookieV2').split('.')[1];
    if (cookieValue) {
      try {
        var decodedCookieValue = (typeof atob !== 'undefined') ? atob(cookieValue) : Base64.decode(cookieValue);
        userData = JSON.parse(decodedCookieValue);
      } catch (e) {
        console.log('Issues decoding TESCookieV2: ' + e.message);
      }
    } else {
      console.log('Something is missing from TESCookieV2');
    }
  }

  var twoYears = 2 * 365 * 86400;
  var aMonth = 30 * 24 * 60 * 60;
  var aDay = 24 * 60 * 60;
  var sevenDays = 24 * 60 * 60 * 7;
  var cookieName = 'nagfooter';
  var apiAck = '/api/marketing/v3/ack';
  var apiCheck = '/api/marketing/v3/check';
  var apiDebug = '/api/marketing/v3/debug';
  var self = this;
  var userId = (user && +user.getId()) || (userData && userData.userId) || null;
  var userIdOrUnauth = userId || 'unauth';

  var nagIdRegExp = / data-nag-id="([^"]+)"/;

  function naggedRecently() {
    return window.Cookies.get(cookieName) === userIdOrUnauth + '';
  }

  function silenceFor(expires) {
    window.Cookies.set(cookieName, userIdOrUnauth, {expires: expires});
  }

  function updateProfile(nagId, actioned) {
    var url = apiAck + '/' + userIdOrUnauth + '/' + nagId;
    nanoajax.ajax({
      url: url,
      method: 'DELETE',
      headers: { 'x-csrf-token': window.Cookies.get('csrf') }
    }, function () {});
  }

  function fetchContent(nagProvider, callback) {
    nanoajax.ajax({
      url: nagProvider,
      method: 'GET'
    }, function (statusCode, response, request) {
      if (statusCode !== 200) {
        callback(new Error(response));
      } else {
        var matches = nagIdRegExp.exec(response);
        var nagId = matches ? matches[1] : 'unknown';
        callback(null, nagId, response);
      }
    });
  }

  function trackShow(nagName, isDebug) {
    if (!isDebug) {
      window._mz && window._mz.emit(window._mze.DISPLAY, {
        module: {
          type: 'nag-footer',
          name: nagName
        }
      });
    } else {
      console.log('nag-footer show', nagName);
    }
  }

  function trackClose(nagName, isDebug) {
    if (!isDebug) {
      window._mz && window._mz.emit(window._mze.CLOSE, {
        module: {
          type: 'nag-footer',
          name: nagName
        }
      });
    } else {
      console.log('nag-footer close', nagName);
    }
  }

  function trackAccept(nagName, payload, isDebug) {
    if (!isDebug) {
      if (typeof payload === "string") {
        try {
          payload = JSON && JSON.parse && JSON.parse(payload);
        } catch (ex) {
          console.log('Unable to parse nag accept payload as JSON, ignoring ...');
          payload = {};
        }
      }
      window._mz && window._mz.emit(window._mze.ACCEPT, {
        module: {
          type: 'nag-footer',
          name: nagName
        },
        payload: payload || {}
      });
    } else {
      console.log('nag-footer accept', nagName, payload);
    }
  }

  function render(nagId, content, isDebug) {
    var domContent = document.createElement('div');
    domContent.innerHTML = trim(content);

    if(domContent.querySelector('.nag-box--top, .nag-box--thin-top')) {
      // we need the html to push the content down as it's not fixed
      prependToBody(domContent);
    } else {
      appendToBody(domContent);
    }
    // here
    var nag = document.querySelector('.nag-footer, .js-nag-box');
    self.nagId = nagId;
    trackShow(nagId, isDebug);

    delegate(nag, '.nag-close, .js-nag-box__close', 'click', function(e) {
      trackClose(nagId, isDebug);
      self.close(nagId, nag);
    }, false);

    delegate(nag, '.nag-accept, .js-nag-box__btn-accept', 'click', function(e) {
      trackAccept(nagId, e.delegateTarget.getAttribute('data-payload'), isDebug);
      self.close(nagId, nag, true);
    }, false);

    delegate(nag, '.js-nag-box__select-accept', 'blur', function(e) {
      var selectValue = e.delegateTarget.value;
      if (selectValue !== 'default') {
        trackAccept(nagId, selectValue, isDebug);
        self.close(nagId, nag, true);
      }
    }, false);
  }

  this.close = function (nagId, nag, actioned) {
    document.body.classList.remove('nag-box--open');
    nag.parentNode.removeChild(nag);
    var addendumSuccess = document.querySelector('.nag-addendum-success, .js-nag-box-addendum');
    if (addendumSuccess && actioned) {
      addendumSuccess.style.display = 'block';
      addendumSuccess.classList.remove('hide');
      delegate(addendumSuccess, '.nag-close, .js-nag-box__close', 'click', function (e) {
        addendumSuccess.parentNode.removeChild(addendumSuccess);
      }, false)
    }
    silenceFor(sevenDays);
    updateProfile(nagId, actioned);
  };

  this.show = function () {
    if (naggedRecently()) return;
    fetchContent(apiCheck + '/' + userId, function (err, nagId, content) {
      if (err) {
        console.log('Nag: Network error');
        return;
      }
      if (!content) return;
      if (!nagId) {
        console.log('Content missing id; may be server or network error or incorrect HTML');
        return;
      }
      render(nagId, content);
      document.body.classList.add('nag-box--open');
    });
  };

  this.debug = function (nagId) {
    // close existing nag if shown to prevent nags piling up and becoming unresponsive
    var closeExistingNag = document.querySelector('.nag-box .js-nag-box__close');
    if (closeExistingNag) {
      closeExistingNag.click();
    }
    fetchContent(apiDebug + '/' + nagId, function (err, nagId, content) {
      if (err) {
        console.log(err.responseCode || 'Nag: Network error');
        return;
      }
      if (!content) return;
      render(nagId, content, true);
    });
  };
};

if (!window.TES.NagFooter) {
  window.TES.NagFooter = NagFooter;
  if(window.TES.preventNagFooterOnLoad !== true) {
    window.addEventListener("load", function load(event) {
      window.removeEventListener("load", load, false);
      new window.TES.NagFooter(window.TES.user).show();
    }, false);
  }
}

},{"classlist-polyfill":1,"delegate":3,"nanoajax":4}]},{},[5]);
